export function fromUrlFilename(url) {
  if (!url) return url;
  return url.split('/').pop();
}

export function ecomGetProductTagType(product) {
  const isUnlockMedia = product.product_purpose === 'partial_unlock_media';
  const requireTag = product.require_tags || product.require_tag;
  const denyTag = product.deny_tags || product.deny_tag;
  const resProdTypes = {
    acceptTags: [],
    denyTags: [],
    isUnlockMedia,
  };
  if (requireTag) {
    resProdTypes.acceptTags = requireTag.split(',').map((item) => item.trim());
  }
  if (denyTag) {
    resProdTypes.denyTags = denyTag.split(',').map((item) => item.trim());
  }
  return resProdTypes;
}

export function ecomCheckProductTagTypeAndImageTag(imgUrl, prodTag) {
  if (
    !prodTag ||
    (!Array.isArray(prodTag.acceptTags) && !Array.isArray(prodTag.denyTags)) ||
    (prodTag.acceptTags?.length === 0 && prodTag.denyTags?.length === 0)
  ) {
    return true;
  }

  const fileName = imgUrl ? fromUrlFilename(imgUrl) : '';
  const { acceptTags = [], denyTags = [] } = prodTag;

  const isPassedAccept = acceptTags.length === 0 || acceptTags.some((tag) => fileName.includes(tag));
  const isPassedDeny = isPassedAccept && !denyTags.some((tag) => fileName.includes(tag));

  return isPassedAccept && isPassedDeny;
}

export function ecomCheckProductTagTypeForAllImages(imgPaths, prodTags) {
  if (
    !prodTags ||
    (!prodTags?.acceptTags && !prodTags?.denyTags) ||
    (prodTags?.acceptTags?.length === 0 && prodTags?.denyTags?.length === 0) ||
    !imgPaths ||
    imgPaths.length === 0
  ) {
    return true;
  }
  let showProduct = false;
  for (let i = 0; i < imgPaths.length; i += 1) {
    showProduct = showProduct || ecomCheckProductTagTypeAndImageTag(imgPaths[i], prodTags);
  }
  return showProduct;
}
